import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

const AchievementWidgetFooterSkeleton = ({
  header,
  rowItems = [],
  footerLink,
  widgetType,
}) => {
  return (
    <>
      <Box height={1} width="100%" backgroundColor="gray88" mb="1x" mt="4x" />
      <Box
        gridGap={{ _: '2x', tablet: '3x' }}
        display="inline-grid"
        gridTemplateColumns={{
          _: widgetType === 'flashcards' ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
          tablet: 'repeat(4, auto)',
        }}
      >
        <Box gridColumn="1/-1" variant="text.tinyTitle">
          {header}
        </Box>
        {rowItems}
      </Box>
      <Box mt="3x">{footerLink}</Box>
    </>
  )
}

AchievementWidgetFooterSkeleton.propTypes = {
  header: PropTypes.any.isRequired,
  rowItems: PropTypes.any,
  footerLink: PropTypes.any,
  widgetType: PropTypes.string,
}

export default AchievementWidgetFooterSkeleton
